import { IconButton, lighten, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";
import "swiper/css";
import "swiper/css/pagination";
import { ArrowLeftIcon, ArrowRightIcon } from "../icons";

type Props = {
  primaryColor: string;
  sliderId: string;
};

export default function SliderNavigation({ primaryColor, sliderId }: Props) {
  return (
    <>
      <SliderNavigationButton
        className={`swiper-button-prev-${sliderId}`}
        primaryColor={primaryColor}
        icon={<ArrowLeftIcon color={primaryColor} />}
        sx={{
          left: 0,
          transform: "translate(-50%, -50%)",
        }}
      />
      <SliderNavigationButton
        className={`swiper-button-next-${sliderId}`}
        primaryColor={primaryColor}
        icon={<ArrowRightIcon color={primaryColor} />}
        sx={{
          right: 0,
          transform: "translate(50%, -50%)",
        }}
      />
    </>
  );
}

type SliderNavigationButtonProps = {
  className: string;
  primaryColor: string;
  icon: ReactNode;
  sx: SxProps<Theme>;
};

const SliderNavigationButton = ({
  className,
  primaryColor,
  icon,
  sx,
}: SliderNavigationButtonProps) => {
  return (
    <IconButton
      className={className}
      sx={{
        zIndex: 1000,
        width: "48px",
        height: "48px",
        backgroundColor: lighten(primaryColor, 0.8),
        "&:hover": {
          backgroundColor: lighten(primaryColor, 0.7),
        },
        top: "50%",
        position: "absolute",
        transition: "all 0.3s ease",
        "&.swiper-button-disabled": {
          opacity: 0,
          visibility: "hidden",
        },
        ...sx,
      }}
    >
      {icon}
    </IconButton>
  );
};
